import React from "react"

import { MENU_CONFIG } from "../../config/menu.config"
import { ScreenTabsLayoutElement } from "../../elements/screenTabsLayout.element"
import { AccountDetailsComponent } from "./accountDetails.component"

export const ProfileComponent: React.FunctionComponent = () => {
    return (
        <ScreenTabsLayoutElement
            tabs={MENU_CONFIG.profileAvailableTabs}
            renderTabContent={tab => {
                switch (tab.key) {
                    case "account":
                        return <AccountDetailsComponent />

                    default:
                        return null
                }
            }}
        />
    )
}
